import { IonRow } from "@ionic/react";

import "../../IonColor/color.css";

import Like from "./Like";

interface ContainerProps {
  like?: number;
  share?: number;
  comments: number;
  hidden: boolean;
  state: string;
  id: string;
  hasLike: boolean;
}

const Footer: React.FC<ContainerProps> = ({ like, id, hasLike }) => {
  return (
    <IonRow className="ion-justify-content-center">
      <Like like={like ? like : 0} id={id} hasLike={hasLike} />
    </IonRow>
  );
};

export default Footer;
